// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/fonts/Nunito/Nunito.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep.matacc .mat-expansion-panel-header .mat-content {
  height: 24px !important;
  font-family: montserrat, sans-serif !important;
}
::ng-deep.matacc .mat-expansion-panel-body {
  background-color: #f7f7f7 !important;
}

::ng-deep.matacclab .mat-expansion-panel-header .mat-content {
  height: 24px !important;
  font-family: Nunito, sans-serif !important;
}
::ng-deep.matacclab .mat-expansion-panel-body {
  background-color: #f7f7f7 !important;
}

.caseclaim-timeline:before {
  content: "";
  position: relative;
  height: 10px;
  width: 10px;
  background-color: yellow;
  border-color: yellow;
  border-style: solid;
  border-width: 3px;
  margin-left: -9px;
  top: 17px;
  border-radius: 50%;
  display: inline-flex;
}

.caseclaim-timeline {
  border-color: #17a0b4;
  border-style: solid;
  border-width: 0 0 0 2px;
  margin-left: 11%;
  height: 12vh;
  padding-top: 13px;
}

.caseclaim-timelineexp {
  border-color: #17a0b4;
  border-style: solid;
  border-width: 0 0 0 2px;
  margin-left: 11%;
  height: 18vh;
  padding-top: 13px;
}

.caseclaim-timelineexp:before {
  content: "";
  position: relative;
  height: 10px;
  width: 10px;
  background-color: yellow;
  border-color: yellow;
  border-style: solid;
  border-width: 3px;
  margin-left: -9px;
  top: 17px;
  border-radius: 50%;
  display: inline-flex;
}

.perfdate {
  padding-top: 15px;
  margin-left: -158px;
  width: 11.5em;
  text-align: right;
  font-size: 12px;
}

.casedetail {
  margin-left: 3%;
  text-align: left;
  padding: 5px;
  position: relative;
  bottom: 8px;
  background-color: rgba(120, 130, 140, 0.13);
  width: 80%;
  font-size: 12px;
}

.expcontent {
  min-height: 20vh;
  max-height: 45vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: montserrat, sans-serif !important;
}

.expcontentlab {
  min-height: 20vh;
  max-height: 45vh;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: Nunito, sans-serif !important;
}

.cardexp {
  min-height: 68vh;
  max-height: 68vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.claimnotes {
  width: 86%;
  height: 20px;
}

.claimnotesexp {
  width: 86%;
  min-height: 20px;
  max-height: 60px;
  overflow-x: hidden;
  overflow-y: auto;
}

.expanddiv {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background-color: #17a0b4;
}

.expandmore {
  font-size: 18px;
  color: black;
}

.expandless {
  font-size: 18px;
  color: black;
}

.timezone-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 8px 80px;
  height: 40px;
  z-index: 1000;
}
.timezone-notice .timezone-notice-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
  height: 100%;
  padding-left: 15px;
}
.timezone-notice .timezone-notice-content i {
  margin-right: 8px;
  color: #17a2b8;
  font-size: 14px;
}
.timezone-notice .timezone-notice-content span {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/caseclaim/caseclaim.component.scss"],"names":[],"mappings":"AAIQ;EACI,uBAAA;EACA,8CAAA;AAFZ;AAKI;EACI,oCAAA;AAHR;;AAQQ;EACI,uBAAA;EACA,0CAAA;AALZ;AAQI;EACI,oCAAA;AANR;;AAUA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AAPJ;;AASA;EACI,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AANJ;;AAQA;EACI,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AALJ;;AAOA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AAJJ;;AAMA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;AAHJ;;AAKA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,2CAAA;EACA,UAAA;EACA,eAAA;AAFJ;;AAIA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AADJ;;AAGA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;AAAJ;;AAEA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AACA;EACI,UAAA;EACA,YAAA;AAEJ;;AAAA;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAGJ;;AADA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAIA;;AAFA;EACI,eAAA;EACA,YAAA;AAKJ;;AAHA;EACI,eAAA;EACA,YAAA;AAMJ;;AAFA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAKF;AAHE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAKJ;AAHI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAKN;AAFI;EACE,gBAAA;AAIN","sourcesContent":["@import 'src/assets/fonts/Nunito/Nunito.css';\r\n\r\n::ng-deep.matacc{\r\n    .mat-expansion-panel-header{\r\n        .mat-content{\r\n            height: 24px !important;\r\n            font-family: montserrat, sans-serif !important;\r\n        }\r\n    }\r\n    .mat-expansion-panel-body{\r\n        background-color: #f7f7f7 !important;\r\n    }\r\n}\r\n::ng-deep.matacclab{\r\n    .mat-expansion-panel-header{\r\n        .mat-content{\r\n            height: 24px !important;\r\n            font-family: Nunito, sans-serif  !important;\r\n        }\r\n    }\r\n    .mat-expansion-panel-body{\r\n        background-color: #f7f7f7 !important;\r\n    }\r\n}\r\n\r\n.caseclaim-timeline:before{\r\n    content: \"\";\r\n    position: relative;\r\n    height: 10px;\r\n    width: 10px;\r\n    background-color: yellow;\r\n    border-color: yellow;\r\n    border-style: solid;\r\n    border-width: 3px;\r\n    margin-left: -9px;\r\n    top: 17px;\r\n    border-radius: 50%;\r\n    display: inline-flex;\r\n}\r\n.caseclaim-timeline{\r\n    border-color: #17a0b4;\r\n    border-style: solid;\r\n    border-width: 0 0 0 2px;\r\n    margin-left: 11%;\r\n    height: 12vh;\r\n    padding-top: 13px;\r\n}\r\n.caseclaim-timelineexp{\r\n    border-color: #17a0b4;\r\n    border-style: solid;\r\n    border-width: 0 0 0 2px;\r\n    margin-left: 11%;\r\n    height: 18vh;\r\n    padding-top: 13px;\r\n}\r\n.caseclaim-timelineexp:before{\r\n    content: \"\";\r\n    position: relative;\r\n    height: 10px;\r\n    width: 10px;\r\n    background-color: yellow;\r\n    border-color: yellow;\r\n    border-style: solid;\r\n    border-width: 3px;\r\n    margin-left: -9px;\r\n    top: 17px;\r\n    border-radius: 50%;\r\n    display: inline-flex;\r\n}\r\n.perfdate{\r\n    padding-top: 15px;\r\n    margin-left: -158px;\r\n    width: 11.5em;\r\n    text-align: right;\r\n    font-size: 12px;\r\n}\r\n.casedetail{\r\n    margin-left: 3%;\r\n    text-align: left;\r\n    padding: 5px;\r\n    position: relative;\r\n    bottom: 8px;\r\n    background-color: rgba(120, 130, 140, 0.13);\r\n    width: 80%;\r\n    font-size: 12px;\r\n}\r\n.expcontent{\r\n    min-height: 20vh;\r\n    max-height: 45vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    font-family: montserrat, sans-serif !important;\r\n}\r\n.expcontentlab{\r\n    min-height: 20vh;\r\n    max-height: 45vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    font-family: Nunito, sans-serif !important;\r\n}\r\n.cardexp{\r\n    min-height: 68vh;\r\n    max-height: 68vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n.claimnotes{\r\n    width: 86%;\r\n    height: 20px;\r\n}\r\n.claimnotesexp{\r\n    width: 86%;\r\n    min-height: 20px;\r\n    max-height: 60px;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n.expanddiv{\r\nheight: 18px;\r\nwidth: 18px;\r\nborder-radius: 50%;\r\nbackground-color: #17a0b4;\r\n}\r\n.expandmore{\r\n    font-size: 18px;\r\n    color: black;\r\n}\r\n.expandless{\r\n    font-size: 18px;\r\n    color: black;\r\n}\r\n\r\n// Timezone Notice Styles - Fixed at bottom of screen\r\n.timezone-notice {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: #f8f9fa;\r\n  border-top: 1px solid #dee2e6;\r\n  padding: 8px 80px;\r\n  height: 40px;\r\n  z-index: 1000;\r\n  \r\n  .timezone-notice-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    font-size: 12px;\r\n    color: #6c757d;\r\n    font-style: italic;\r\n    height: 100%;\r\n    padding-left: 15px;\r\n    \r\n    i {\r\n      margin-right: 8px;\r\n      color: #17a2b8;\r\n      font-size: 14px;\r\n    }\r\n    \r\n    span {\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
